import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { message } from 'antd';
import ChangePassword from '../../components/ChangePassword';
import Terms_Conditions from '../../components/Terms_Conditions';
import { fbFunctionsURL } from '../../config.js';
import axios from 'axios';

class ModalPassAndTerm extends React.Component {
  state = {
    classes: null,
    changePass: false,
    termsModal: false
  };

  componentDidMount(prevProps) {
    if (
      !this.state.termsModal &&
      this.props.profile &&
      !this.props.profile.termsAccepted
    ) {
      this.setState({ termsModal: true });
    }

    if (
      this.props.profile &&
      this.props.profile.termsAccepted &&
      !this.state.changePass
    ) {
      if (this.props.profile.changePassword) {
        this.setState({ changePass: true });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !this.state.termsModal &&
      this.props.profile &&
      !this.props.profile.termsAccepted
    ) {
      this.setState({ termsModal: true });
    }

    if (
      this.props.profile &&
      this.props.profile.termsAccepted &&
      !this.state.changePass
    ) {
      if (this.props.profile.changePassword) {
        this.setState({ changePass: true });
      }
    }
  }

  changePass = psw => {
    // console.log('changepass', psw);
    const _this = this;
    const email = this.props.firebase.auth().currentUser.email;
    const uid = this.props.auth.uid;
    const password = 'SkillTracker';
    const credential = this.props.firebase.auth.EmailAuthProvider.credential(
      email,
      password
    );
    this.props.firebase
      .auth()
      .currentUser.getIdToken()
      .then(token => {
        const config = {
          url: `${fbFunctionsURL}/register/changePassword`,
          method: 'post',
          data: {
            password: psw,
            uid
          },
          headers: {
            authorization: `Bearer ${token}`
          }
        };
        axios(config)
          .then(() => {
            message.success('Password saved');
            _this.props.firebase
              .database()
              .ref(`/users/${uid}/token`)
              .remove();
            _this.props.firebase
              .database()
              .ref(`/users/${uid}/profile/changePassword`)
              .remove()
              .then(() => {
                _this.setState({ changePass: false });
                _this.props.resetRedirect();
              });
          })
          .catch(function(error) {
            message.error(error.message);
          });
      });
  };

  acceptTerms = () => {
    const uid = this.props.auth.uid;
    this.props.firebase
      .database()
      .ref(`users/${uid}/profile`)
      .update({
        termsAccepted: true
      });
    this.setState({ termsModal: false });
  };

  render() {
    const { t } = this.props;
    return (
      <div
        style={{
          padding: '0px 40px 40px 40px',
          backgroundColor: 'white',
          margin: '0px 20px 20px 20px'
        }}>
        <ChangePassword
          open={this.state.changePass}
          color={this.state.color}
          changePass={this.changePass}
          t={this.props.t}
        />
        <Terms_Conditions
          t={this.props.t}
          mode={'teacher'}
          open={this.state.termsModal}
          acceptTerms={this.acceptTerms}
        />
      </div>
    );
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect(props => {
    return ['/users'];
  }),
  connect(state => {
    return {
      auth: state.firebase && state.firebase.auth,
      profile: state.firebase && state.firebase.profile.profile
    };
  })
);
export default enhancer(ModalPassAndTerm);



// WEBPACK FOOTER //
// ./src/containers/ModalPassAndTerm/index.js